import { render, staticRenderFns } from "./TheHeadline.vue?vue&type=template&id=2afb2f81&"
import script from "./TheHeadline.vue?vue&type=script&lang=js&"
export * from "./TheHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports